import Splide from '@splidejs/splide';

const EL = '.js-news';

document.querySelectorAll(EL).forEach((el) => {
  const slider = new Splide(el, {
    pagination: false,
    fixedWidth: '493px',
    gap: 40,
    arrows: true,
    breakpoints: {
      1365: {
        gap: 20,
        fixedWidth: '400px',
      },
      1024: {
        fixedWidth: '340px',
      },
      767: {
        fixedWidth: '260px',
        gap: 10,
      },
    },
  });

  slider.mount();
});
